import { apiSlice } from './apiSlice';

export const fcmApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    registerFcmDevice: builder.mutation<{ success: boolean; message?: string }, { fid: string }>({
      query: (body) => ({
        url: '/firebase/firebase/devices',
        method: 'POST',
        body,
      }),
    }),
    deleteFcmDevice: builder.mutation<{ success: boolean; message?: string }, string>({
      query: (fid) => ({
        url: `/firebase/firebase/devices/${encodeURIComponent(fid)}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useRegisterFcmDeviceMutation, useDeleteFcmDeviceMutation } = fcmApi;
